import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData } from "components/pages/OneTimeACHPaymentPage";
import Classes from "model";

export default function CaptureCCDSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], "CCD Credit - Non-Consumer Credit")
    .submit();

    return <OneTimeACHPaymentPage data={ data } />;
}